import { ArrowLong } from "../../assets/img/svg/icons";
import { U } from "../../assets/img/svg/details";

interface Palestrante {
    nome: string;
    foto: string;
    descricao: string;
}

interface Palestra {
    slug: string;
    horario: string;
    titulo: string;
    palestrante: Palestrante[];
}

const Palestrante: React.FC<{ palestra: Palestra, className?: string }> = ({ palestra, className }) => {
    return (
        <a href={`/palestra/${palestra.slug}`} title={palestra.palestrante[0].nome} className={`group inline-block my-4 px-8 md:odd:border-r md:odd:border-black/20 ${className}`}>
            <div className='py-4 leading-5 text-center text-sm border-b border-black/20'>
                <div className="relative mb-4">
                    <U className='w-[170px] h-[170px] mx-auto'/>
                    <img src={palestra.palestrante[0].foto} alt={palestra.palestrante[0].nome} className='absolute -bottom-2 left-1/2 -translate-x-1/2 w-[140px] h-[140px] rounded-full object-cover transition-all duration-200 group-hover:scale-105' />
                </div>

                <h4 className="font-semibold text-lg">
                    {palestra.palestrante[0].nome}
                </h4>

                <p className='font-semibold'>
                    Palestra: 
                    <span className='font-light'> {palestra.horario} - {palestra.titulo}</span> 
                </p>
            </div>

            <div className="font-semibold text-center mt-4 text-sm relative flex items-center justify-center gap-6 translate-x-8">
                Saiba mais

                <div className="bg-[#00A3E3] w-14 h-8 rounded-lg flex items-center justify-center drop-shadow-xl transition-all duration-200 group-hover:translate-x-2 group-hover:bg-main-blue">
                    <ArrowLong />
                </div>
            </div>
        </a>
    );
};

export default Palestrante;
